import { interpolate, appendHtml } from '../utils';

var template = `
<div class="mobile-modal" id="\${data.id}">
  <div class="mobile-modal_overlay js-overlay-close"></div>
  <div class="mobile-modal_container" style="--modal-height: \${data.height}">
    <div class="mobile-modal_header">
        \${data.title}
        <button type="button" class="mobile-modal_close js-close">
            <img src="/Content/reskin/src/assets/img/gr-close.svg" alt="X" />
        </button>
    </div>
    <div class="mobile-modal_body">
        \${data.content}
    </div>
  </div>
</div>
`;

var defaultOptions = {
    title: 'Mobile Modal',
    content: 'Hello World',
    height: '50%',
    overlayClose: true
};

export default function MobileModal(options) {
    this.config = Object.assign({
        id: `modal_${new Date().valueOf()}`
    }, defaultOptions, options || {});

    this.create();
};

MobileModal.prototype.create = function () {
    var data = this.config;
    var html = interpolate(template, { data: { id: this.config.id, ...data } });
    appendHtml(html);
    this.el = document.getElementById(this.config.id);
    var closeBtn = this.el.querySelector('.js-close');
    closeBtn.addEventListener('click', this.hide.bind(this));

    if (this.config.overlayClose) {
        var overlay = this.el.querySelector('.js-overlay-close');
        overlay.addEventListener('click', this.hide.bind(this));
    }

    this.show();
};

MobileModal.prototype.show = function () {
    this.el.classList.add('mobile-modal--show');
    document.body.style.overflowY = "hidden";
};

MobileModal.prototype.hide = function () {
    this.el.classList.remove('mobile-modal--show');
    document.body.style.overflowY = "auto";
    this.el.remove();
};